import React from 'react';

interface LoadingSpinnerProps {
	size?: number;
	color?: string;
	thickness?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({size = 40, color = '#3498db', thickness = 4}) => {
	const spinnerStyle: React.CSSProperties = {
		width: `${size}px`,
		height: `${size}px`,
		borderWidth: `${thickness}px`,
		borderStyle: 'solid',
		borderColor: 'rgba(0, 0, 0, 0.1)',
		borderTopColor: color,
		borderRadius: '50%',
		animation: 'spin 1s ease-in-out infinite',
	};

	const containerStyle: React.CSSProperties = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	};

	return (
		<div style={containerStyle} className="loading-spinner">
			<div className="spinner" style={spinnerStyle}></div>
			<style>
				{`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
			</style>
		</div>
	);
};

export default LoadingSpinner;
